import { useContext } from 'react';
import { CalendarAuthContext } from 'contexts/calendar_auth_context';

const useCalendarAuth = () => {
    return useContext(CalendarAuthContext);
};

export default useCalendarAuth;
